// extracted by mini-css-extract-plugin
export default {"searchContainer":"Statistics_searchContainer__jzu1I","statisticsContainer":"Statistics_statisticsContainer__3DKxc"};